import { ConsentRow } from "@/components/legal/terms-consent";

/**
 * Only a grown-up may create an account (issue #55): a child is a profile in
 * their parent's account. Unticked to start with, and — like the consent
 * checkboxes beside it — decided on the server: `registerWithEmail` refuses
 * without `confirmsGuardian`, and the Google button only creates an account
 * when it carries `guardian=1`.
 */
export function GuardianConfirmation({
  checked,
  onChange,
  id = "guardian-confirmation",
}: {
  checked: boolean;
  onChange: (value: boolean) => void;
  id?: string;
}) {
  return (
    <ConsentRow id={id} checked={checked} onChange={onChange}>
      Esu vyresnis nei 18 m. ir esu vaiko tėvas, mama ar teisėtas globėjas.
    </ConsentRow>
  );
}
